module.exports = __webpack_public_path__ + "img/customer-a-020.9ef13bff.png";